import React from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import TrackSkeloton from "./trackSkeletion.component";

function Table({
  columns,
  data,
  pageCount,
  isLoading,
  handlePageClick,
  selectedPage,
}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    rows,
    prepareRow,
    gotoPage,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    pageOptions,
    setPageSize = 200,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 1000000 },
    },
    usePagination
  );

  const PageRows = rows;

  return (
    <>
      <div className="mt-2 flex flex-col">
        <div className="-my-2 overflow-x-auto -mx-4 sm:-mx-6 lg:-mx-8">
          <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
              <table
                {...getTableProps()}
                className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  {headerGroups.map((headerGroup) => (
                    <tr {...headerGroup.getHeaderGroupProps()}>
                      {headerGroup.headers.map((column, ind) => (
                        // Add the sorting props to control sorting. For this example
                        // we can add them into the header props
                        <th
                          scope="col"
                          className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${
                            column.id === "_id" ? "w-36" : ""
                          } ${column.id === "category" ? "w-28" : ""} ${
                            column.id === "isActive" ? "w-16" : ""
                          }`}
                          key={ind}
                          // {...column.getHeaderProps(column.getSortByToggleProps())}
                        >
                          {column.render("Header")}
                          {/* Add a sort direction indicator */}
                          <span>
                            {column.isSorted
                              ? column.isSortedDesc
                                ? " ▼"
                                : " ▲"
                              : ""}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                {isLoading && <TrackSkeloton />}
                {!isLoading && data.length > 0 ? (
                  <tbody
                    {...getTableBodyProps()}
                    className="bg-white divide-y divide-gray-200">
                    {page.map((row, i) => {
                      prepareRow(row);
                      return (
                        <tr {...row.getRowProps()}>
                          {row.cells.map((cell) => {
                            return (
                              <td
                                {...cell.getCellProps()}
                                className={`whitespace-nowrap t-grey ${
                                  cell.getCellProps().key.includes("imageURL")
                                    ? "px-0 py-0 w-28"
                                    : "px-6 py-4"
                                } ${
                                  cell
                                    .getCellProps()
                                    .key.includes("description") ||
                                  cell.getCellProps().key.includes("title") ||
                                  cell.getCellProps().key.includes("speaker") ||
                                  cell.getCellProps().key.includes("name")
                                    ? "max-w-0"
                                    : ""
                                } ${
                                  cell.getCellProps().key.includes("name")
                                    ? "max-w-0 w-1/2"
                                    : ""
                                }`}>
                                {cell.render("Cell")}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                ) : (
                  <></>
                )}
              </table>
            </div>
            {data.length > 0 && pageCount && !isLoading && (
              <nav aria-label="Page navigation example" className="text-center">
                <ul className="inline-flex items-center -space-x-px list-none">
                  <li>
                    <button
                      className="block px-3 py-2 ml-0 leading-tight text-gray-500 bg-white border border-gray-300 rounded-l-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageClick("prev")}>
                      {/* <span className="sr-only">Previous</span> */}
                      <svg
                        aria-hidden="true"
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                          clipRule="evenodd"></path>
                      </svg>
                    </button>
                  </li>
                  <span className="px-3">
                    Page{" "}
                    <strong>
                      {selectedPage} of {pageCount}
                    </strong>{" "}
                  </span>
                  <li>
                    <button
                      className="block px-3 py-2 leading-tight text-gray-500 bg-white border border-gray-300 rounded-r-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
                      onClick={() => handlePageClick("next")}>
                      <svg
                        aria-hidden="true"
                        className="w-5 h-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          fillRule="evenodd"
                          d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                          clipRule="evenodd"></path>
                      </svg>
                    </button>
                  </li>
                </ul>
              </nav>
            )}
          </div>
        </div>
      </div>
      {/* {data.length === 0 ? (
        <div className="w-full text-center mt-4">
          <span className="text-gray-600 text-xs text-center">
            No rows found
          </span>
        </div>
      ) : null} */}
      <br />
    </>
  );
}

export default Table;
